module.exports = __webpack_public_path__ + "img/z-solution-icon2.dd4840e6.png";